import { decodeURISearchPart } from 'httongue';
import { parseURLRoute } from './url-route.impl.js';
/**
 * @internal
 */
function parseURLEntry(raw) {
    return { name: decodeURISearchPart(raw), raw, rawName: raw };
}
/**
 * Constructs a route by URL.
 *
 * @param url - Source URL. If string given, then URL will be constructed relatively to `route:/` base.
 *
 * @returns New URL route instance.
 */
export function urlRoute(url) {
    return parseURLRoute(url, parseURLEntry);
}
//# sourceMappingURL=url-route.js.map